module.exports = __webpack_public_path__ + "pc/img/img_award2022_02.4930c9d4.webp";